<template>
  <div class="media-list">
    <div class="breadcrumb-bar">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/grant' }"
          >授权课程</el-breadcrumb-item
        >
        <el-breadcrumb-item>课程详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="main-box">
      <Card style="margin-bottom: 10px">
        <div class="panel-box">
          <h3 class="panel-title">课包基本信息</h3>
          <div class="panel-content">
            <el-form :inline="true" :model="showPkg" label-width="90px">
              <el-form-item label="课包名称:">
                <p>{{ showPkg.name }}</p>
              </el-form-item>
              <el-form-item label="课包ID:">
                <p>{{ showPkg.id }}</p>
              </el-form-item>
              <br />
              <el-form-item label="级别:">
                <p>{{ showPkg.level }}</p>
              </el-form-item>
              <br />
              <el-form-item label="封面:">
                <img :src="showPkg.image" width="80px" height="80px" />
              </el-form-item>
              <br />
              <el-form-item label="周期:">
                <p>{{ showPkg.period }}课程</p>
              </el-form-item>
              <br />
              <!-- <el-form-item label="数量:">
                <p>{{ showPkg.count }}</p>
              </el-form-item> -->
              <el-form-item label="课程类型:">
                <!-- <p> <span v-if="showPkg.packageType == 1">体系课</span>
              <span v-if="showPkg.packageType == 2">特色课程</span></p> -->
              <span >体系课</span>
              </el-form-item>
              <!-- <el-form-item label="使用时间:">
                <p>{{ showPkg.count }}</p>
              </el-form-item> -->
              <br />
            </el-form>
          </div>
        </div>
      </Card>
      <el-table
        stripe
        tooltip-effect="dark"
        :data="detailData"
        style="width: 100%"
      >
        <el-table-column
        align="center"
        prop="appId"
        label="机构ID"
        width="180">
      </el-table-column>
      <el-table-column
      align="center"
        prop="name"
        label="机构名称"
        width="180">
      </el-table-column>
      <el-table-column
     align="center"
     prop="authInfo"
     label="到期时间">
      <template slot-scope="scope">
        <span v-if="scope.row.authInfo.length!=0">
          {{scope.row.authInfo[0] |formatDate2}} 至 {{scope.row.authInfo[1]|formatDate2}}
        </span>
        <span v-else>已取消授权</span>
      </template>
      
      </el-table-column>
      <el-table-column
      align="center"
      label="操作日志">
          <template slot-scope="scope">
            <el-tooltip content="操作日志" placement="top">
              <el-button
                type="primary"
                icon="el-icon-document"
                @click="handleEdit(scope.row)"
                size="mini"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" label="管理">
            <template slot-scope="scope">
              <span v-if="scope.row.authInfo.length!=0">
                <el-button type="primary" size="mini" @click="deleSN(scope.row.appId)">取消授权</el-button>
              </span>
              <span v-else></span>
            </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryParams.page"
          :page-sizes="[10,20, 50, 100]"
          :page-size="queryParams.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal1"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { ApiMessage, formatDate } from "@/utils/util";
import stUpdated from "../componentsEdu/stUpdated";

export default {
  name: "detailAuthorization",
  components: { stUpdated },
  data() {
    return {
      detailData: [],
      startData:'',
      endData:'',
      showPkg: {
        id: "",
        name: "",
        level: "",
        image: "",
        period: null,
        count: null,
        courseType:""
      },
      courseData: [],
      formCourse: {
        period: "",
        name: "",
        level: "",
      },
      currId: null,
      queryParams: {
        page: 1,
        pageSize: 20,
      },
      pageTotal1: 0,
      periodTxt: "",
      classId: null,
      type: "",
      needCourseId:'',
      finishData:[]
    };
  },
  created() {
    this.fetchDetailData();
    if (this.$route.query.classId != undefined) {
      this.classId = `${this.$route.query.classId}`;
    }
    if (this.$route.query.type != undefined) {
      // debugger
      this.type = `${this.$route.query.type}`;
      console.log(this.$route.query.type, "8888888888");
    }
    if (this.$route.query.id != undefined) {
      this.currId = `${this.$route.query.id}`;
      let params = {
        appId: this.$API.APPID,
        id: this.currId,
        packageType: 1,
      };

      this.eduAxiosPostRequest(
        "/edu/eduAdmin/course/package_list",
        params
      ).then((res) => {
        if (res != null) {
          // debugger
          let m = JSON.parse(res).list[0];
          this.showPkg.id = m.id;
          this.showPkg.name = m.name;
          this.showPkg.level = m.level;
          this.showPkg.image = m.image;
          this.showPkg.packageType = m.packageType;

          if (m.period == 1) {
            this.showPkg.period = "日";
            this.periodTxt = "日";
          } else if (m.period == 2) {
            this.showPkg.period = "周";
            this.periodTxt = "周";
          } else if (m.period == 3) {
            this.showPkg.period = "月";
            this.periodTxt = "月";
          }
          this.showPkg.count = m.count;
          this.fetchCourseList();
        }
      });
    }
  },
  watch: {},
  filters:{
    formatDate2(val){
      return formatDate(val,'yyyy-MM-dd')
    }
  },
  methods: {
    deleSN(appId){
    this.needCourseId = `${this.$route.query.id}`;
     let nowOrgan=this.detailData.filter(dtData=>{
        return appId==dtData.appId
      })
    
      this.$Modal.confirm({
        title: "提示",
        content: "<ul><li>是否要停止【"+nowOrgan[0].name+"】的授权</li></ul>",
        onOk: () => {
          console.log(666666);
          let params={
            appId:this.$API.APPID,
            resourceId:Number(this.needCourseId),
            resourceType:1,
            targetAppIds:Array(appId),
            startTime:0,
            endTime:0
          }
          this.$axios.post('edu/eduAdmin/course/fyd_set_auth_info',params).then((response)=>{
            if(response.data.rc==0){
              this.fetchDetailData()
              this.$message.success('停止授权成功')
              for(let i=0;i<this.finishData.length;++i){
                if(appId==this.finishData[i].appId){
                  this.finishData.splice(i,1);
                  break;
                }
              }
            }
          })
        },
      });
    },
    handleEdit(val) {
      let neeId = val.appId;
      let getCurrId = `${this.$route.query.id}`;
      let routeUrl = this.$router.resolve({
        name: "doAuthor",
        query: {
          neeId: neeId,
          id: getCurrId,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    fetchDetailData() {
      this.needCourseId = `${this.$route.query.id}`;
      console.log(this.needCourseId,'需要的课包id');
      let params = {
        appId: this.$API.APPID,
        resourceId: Number(this.needCourseId),
        resourceType: 1,
        pageSize: this.queryParams.pageSize,
        page: this.queryParams.page,
        operHistory: true,
      };
      this.$axios
        .post("edu/eduAdmin/course/fyd_get_auth_list", params)
        .then((response1) => {
          console.log(response1,'respone1-------------');
          if (response1 != null) {
            this.detailData = response1.data.data.list;
            this.pageTotal1 = response1.data.data.pager.total;
            console.log(this.pageTotal1,'this.pageTotal======================');
            for (let i = 0; i < this.detailData.length; ++i) {
              if (this.detailData[i].authInfo.length!=0) {
                this.finishData .push(this.detailData[i]) ;
              }
            }
          }
        });
        
  },
    editstUpdated(val) {
      let updatedTime = val.updatedTime;
      let order = val.order;
      let courseId = val.courseId;
      let params = {
        appId: this.$API.APPID,
        courseId: courseId, //必须，课ID
        order: order, //必须，课的序号
        classId: this.classId, //必须，班级ID
        date: formatDate(updatedTime, "yyyy-MM-dd"), //必须，课的更新时间
      };
      //  debugger
      this.$axios
        .post("/edu/eduAdmin/course/save_cls_update_date", params)
        .then((response) => {
          if (response != null) {
            if (response.data.rc == 0) {
              this.$Message.success("操作成功!");
              this.fetchCourseList();
            } else {
              alert(response.data.err);
            }
          }
        });
    },
    confirmSubmit() {
      this.$router.push({
        name: "courseList",
      });
    },
    onQuery() {
      this.fetchCourseList();
    },
    fetchCourseList() {
      let params2 = {
        appId: this.$API.APPID,
        packageId: `${this.currId}`,
        page: this.queryParams.page,
        pageSize: this.queryParams.pageSize,
        classId: this.classId,
        // level:this.level
      };
      if (this.formCourse.period != "") {
        params2.order = Number(this.formCourse.period) - 1;
      }
      if (this.formCourse.name != "") {
        params2.name = this.formCourse.name;
      }
      if (this.formCourse.level != "") {
        params2.level = this.formCourse.level;
      }
      this.eduAxiosPostRequest(
        "/edu/eduAdmin/course/course_list",
        params2
      ).then((res2) => {
        if (res2 != null) {
          let m2 = JSON.parse(res2);
          this.courseData = m2.list;
          this.pageTotal = m2.pager.total;
          this.step = 2;
        }
      });
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.fetchDetailData();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.fetchDetailData();
    },
    viewAlbum(albumId) {
      // debugger
      console.log(albumId);
      let routeUrl = this.$router.resolve({
        name: "packageCourseDetail",
        query: {
          id: albumId,
          do: "view",
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    eduAxiosPostRequest(address, params) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(address, params)
          .then((response) => {
            console.log(response);
            if (response.data.rc == "0") {
              resolve(JSON.stringify(response.data.data));
            } else {
              alert(response.data.rc + ". " + response.data.err);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
  },
};
</script>

<style lang="less">
@import "../fyd-style";
@import "../commonEdu";
</style>


// WEBPACK FOOTER //
// detailAuthorization.vue?ef9c0756